// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-button {
  display: inline-block;
  flex-shrink: 0;
  flex-basis: 100px;
  min-width: 100px;

  vertical-align: middle;

  margin: 0.25rem;

  border-radius: 4px;
  border-style: solid;
  border-width: 1px;

  padding: 6px 12px;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  line-height: 1.4286;

  touch-action: manipulation;
  cursor: pointer;
  user-select: none;

  img[src=""] {
    display: none;
  }

  img {
    height: 1.5em;
    vertical-align: middle;
    padding-right: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./frontend/widget/action-button.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;;EAEhB,sBAAsB;;EAEtB,eAAe;;EAEf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;;EAEjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;;EAEjB;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":[".action-button {\n  display: inline-block;\n  flex-shrink: 0;\n  flex-basis: 100px;\n  min-width: 100px;\n\n  vertical-align: middle;\n\n  margin: 0.25rem;\n\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 1px;\n\n  padding: 6px 12px;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  line-height: 1.4286;\n\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n\n  img[src=\"\"] {\n    display: none;\n  }\n\n  img {\n    height: 1.5em;\n    vertical-align: middle;\n    padding-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
